import { setShowViewEmailModal } from '../State/showViewEmailModal';
import { setSelectedEmailId } from '../State/selectedEmailId';

export default () => async (dispatch) => {

  dispatch(setShowViewEmailModal(false));
  dispatch(setSelectedEmailId(null));
  
}